<template>
    <component
        :is="tag"
        :method="method"
        :disabled="processing"
        @[trigger].prevent="request"
    >
        <slot v-bind="this"></slot>
    </component>
</template>

<script>
    export default {
        name: 'VAction',
        props: {
            tag: {
                type: String,
                default: 'button',
            },
            trigger: {
                type: String,
                default: 'click',
            },
            route: {
                type: String,
                required: true,
            },
            method: {
                type: String,
                default: 'post',
                validator: value => {
                    return ['get', 'post', 'put', 'patch', 'delete'].indexOf(value) !== -1;
                }
            },
            data: {
                type: [Object, FormData, Function],
            },
            config: {
                type: Object,
            },
        },
        data() {
            return {
                processing: false,
            };
        },
        watch: {
            processing(value) {
                this.$emit('processing', value);
            },
        },
        methods: {
            request(event) {
                this.processing = true;

                const data = this.getData() || {};
                if (typeof data.append === 'function') {
                    data.append('_method', this.method);
                } else {
                    Object.assign(data, {
                        _method: this.method,
                    })
                }
//                for (let pair of data.entries()) {
//                    console.log(pair[0] + ": " + pair[1]);
//                }

                axios.request({
                    url: this.route,
                    method: 'post',
                    data: data,
                    ...this.config,
                }).then(response => {
                    this.$emit('success', response);
                }).catch(error => {
                    this.$emit('error', error);
                }).then(() => {
                    this.processing = false;
                });
            },
            getData() {
                return typeof this.data === 'function' ? this.data() : this.data;
            },
        },
    }
</script>